import { mutatorAction } from 'satcheljs';
import { getComposeStore } from '../selectors/getComposeStore';
import type {
    FullComposeViewState,
    QuickComposeViewState,
    MetricsInfo,
    AttachmentFiles,
} from 'owa-calendar-compose-types';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ComposeFormType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export const setViewState = mutatorAction(
    'setViewState',
    (formId: string, viewState: FullComposeViewState | QuickComposeViewState | null) => {
        const store = getComposeStore(formId);

        if (store) {
            store.uiState = viewState;
        }
    }
);

export const setOriginalEvent = mutatorAction(
    'setOriginalEvent',
    (formId: string, originalEvent: CalendarEvent | null) => {
        const store = getComposeStore(formId);

        if (store) {
            store.originalEvent = originalEvent;
        }
    }
);

export const setEvent = mutatorAction('setEvent', (formId: string, event: CalendarEvent | null) => {
    const store = getComposeStore(formId);

    if (store) {
        store.event = event;
    }
});

export const setOpenedForm = mutatorAction(
    'setOpenedForm',
    (formId: string, openedForm: ComposeFormType | null) => {
        const store = getComposeStore(formId);

        if (store) {
            store.openedForm = openedForm;
        }
    }
);

export const setMetricsInfo = mutatorAction(
    'setMetricsInfo',
    (formId: string, metricsInfo: MetricsInfo | null) => {
        const store = getComposeStore(formId);

        if (store) {
            store.metricsInfo = metricsInfo;
        }
    }
);

export const setAttachmentFiles = mutatorAction(
    'setAttachmentFiles',
    (formId: string, attachmentFiles: AttachmentFiles | null) => {
        const store = getComposeStore(formId);

        if (store) {
            store.attachmentFiles = attachmentFiles;
        }
    }
);
